import TextField from "./TextField";
import NumberField from "./NumberFields";
import SelectField from "./SelectField";
import RadioField from "./RadioField";
import CheckboxField from "./CheckboxField";
import FileField from "./FileField";
import LocationField from "./LocationField";

export default function EditFormField(props) {
  switch (props?.field?.presentation) {
    case "TEXT_FIELD":
      return <TextField {...props} />;
    case "NUMBER_FIELD":
      return <NumberField {...props} />;
    case "SELECT":
      return <SelectField {...props} />;
    case "RADIO":
      return <RadioField {...props} />;
    case "CHECKBOX":
      return <CheckboxField {...props} />;
    case "FILE":
      return <FileField {...props} />;
    case "LOCATION":
      return <LocationField {...props} />;
    case "POINT_LOCATION":
      return <LocationField {...props} />;
    default:
      return <TextField {...props} />;
  }
}
